export enum CHIP_LABELS {
  COMPLETED = 'completed',
  OVERDUE = 'overdue',
}

export enum DATE_FORMATS {
  USA = 'MMM DD ',
  DEFAULT = 'DD MMM ',
}

export enum DATE_FORMATS_WITH_DOT {
  USA = 'MMM DD・',
  DEFAULT = 'DD MMM・',
}
